import styled from "styled-components";

import { colors, breakpoints } from '../../../../styles/variables';

export const SH1 = styled.h1`
    font-family: 'Gilroy', sans-serif;
    font-weight: 800;
    font-size: 4rem;
    position: relative;
    margin: 0 0 3rem;
    text-align: center;
    z-index: 1;

    padding-bottom: ${({ titleUnderline }) =>
        ( titleUnderline ? '13px' : 'none')}
    ;

    span {
        box-shadow: ${({ titleUnderline }) =>
            ( titleUnderline ? `inset 0 0 white, inset 0 -25px ${colors.pinkAmour}` : 'none')}
        ;
    }

    @media (min-width: ${ breakpoints.medium }) {
        font-size: 4.8rem;
    }

    @media (min-width: ${ breakpoints.big }) {
        line-height: 9rem;
        font-size: 7.2rem;
    }
`;
